<template>
  <div class="viewTwo">
    <h1>Hola! Esta es la vista 2</h1>
  </div>
</template>

<script>
export default {
  name: 'ViewTwo',
};
</script>

<style scoped>
.viewTwo {
  color: #676767;
  padding: 10px 0 0 50px;
}
</style>
